import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive } from 'vue'
import { ImageBackgroundState, ScrollOffset } from './types'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'

interface Props {
  id: string
  position: string
  dir: string
  sm: string
  md: string
  lg?: string
  altText: string
  scrollOffset: ScrollOffset
  delayFades?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveBackground',
  props: {
    id: null,
    position: null,
    dir: null,
    sm: null,
    md: null,
    lg: null,
    altText: null,
    scrollOffset: null,
    delayFades: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  id: string
  position: string
  dir: string
  sm: string
  md: string
  lg?: string
  altText: string
  scrollOffset: ScrollOffset
  delayFades?: boolean
}



const state: ImageBackgroundState = reactive({
  translate: '',
  scale: '',
  scaleRatio: 1,
  hotspotSize: 0,
  naturalWidth: 1920,
  naturalHeight: 1080,
  proxyPosition: '',
  offsetX: 0,
})

expose({ state })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["absolute w-full h-full overflow-hidden", {
      'responsive-bg': !props.delayFades,
      'responsive-bg-delayed': props.delayFades,
    }])
  }, [
    _createVNode(ResponsiveBackgroundImage, {
      id: props.id,
      dir: props.dir,
      sm: props.sm,
      md: props.md,
      lg: props.lg,
      alt: props.altText,
      style: _normalizeStyle({ objectPosition: props.scrollOffset.proxyPosition }),
      isActive: true
    }, null, 8, ["id", "dir", "sm", "md", "lg", "alt", "style"])
  ], 2))
}
}

})